export const EMPLOYMENT_STATUS_MAPPING = {
  '1': ['17'], // 正社員
  '2': ['18'], // 契約社員
  '3': ['19', '57', '58', '59', '64'], // その他
};

export const HOLIDAY_AND_WAY_OF_WORKING_MAPPING = {
  '1': ['69'], // 完全週休2日制
  '2': ['5'], // 年間休日120日以上
  '3': ['72'], // 土日祝休み
  '4': ['73'], // 5日以上の連続休暇OK
  '5': ['74'], // 原則定時退社
  '6': ['60'], // 残業20時間未満
  '7': ['6'], // フレックス勤務
  '8': ['75'], // 産休・育休取得実績あり
};

export const REQUIREMENTS_MAPPING = {
  '1': ['70'], // 職種未経験歓迎
  '2': ['71'], // 業種未経験歓迎
  '3': ['24'], // 学歴不問
  '4': ['27'], // 転勤なし（勤務地限定）
  '5': ['3'], // 第二新卒歓迎
  '6': ['67'], // 社会人経験10年以上歓迎
  '7': ['76'], // 急募！入社まで1カ月
  '8': ['48'], // 採用人数5名以上
  '9': ['86'], // 入社後の職種変更なし
};

export const WORKPLACE_ENVIRONMENT_MAPPING = {
  '1': ['47'], // 上場企業
  '2': ['4'], // 外資系企業
  '3': ['77'], // 定着率95％以上
  '4': ['33'], // 女性活躍
  '5': ['55'], // 自動車通勤OK
  '6': ['32'], // 服装自由
};

export const WELFARE_BENEFITS_MAPPING = {
  '1': ['56'], // 退職金制度
  '2': ['44'], // 社宅・家賃補助制度
  '3': ['65'], // 育児・託児支援制度
  '4': ['45'], // 資格取得支援制度
  '5': ['46'], // 研修制度充実
  '6': ['79'], // 固定給25万円以上
  '7': ['80'], // 固定給35万円以上
  '8': ['81'], // U・Iターン支援あり
};

export const LANGUAGE_SKILLS_MAPPING = {
  '1': ['21'], // 英語を活かす
  '2': ['49'], // 中国語を活かす
};

export const POSITIONS_MAPPING = {
  '1': ['78'], // 海外出張あり
  '2': ['8'], // 管理職・マネジャー
};

export const EMPLOYEE_AVERAGE_AGE_MAPPING = {
  '1': ['82'], // 20代
  '2': ['83'], // 30代
  '3': ['84'], // 40代
  '4': ['85'], // 50代以上
};

export const LOWER_LIMIT_INCOME_MAPPING = {
  '1': '20', // 200万円
  '2': '25', // 250万円
  '3': '30', // 300万円
  '4': '35', // 350万円
  '5': '40', // 400万円
  '6': '45', // 450万円
  '7': '50', // 500万円
  '8': '55', // 550万円
  '9': '60', // 600万円
  '10': '65', // 650万円
  '11': '70', // 700万円
  '12': '80', // 800万円
  '13': '90', // 900万円
  '14': '100', // 1000万円
};

export const UPPER_LIMIT_INCOME_MAPPING = {
  '1': '20', // 200万円
  '2': '25', // 250万円
  '3': '30', // 300万円
  '4': '35', // 350万円
  '5': '40', // 400万円
  '6': '45', // 450万円
  '7': '50', // 500万円
  '8': '55', // 550万円
  '9': '60', // 600万円
  '10': '65', // 650万円
  '11': '70', // 700万円
  '12': '80', // 800万円
  '13': '90', // 900万円
  '14': '100', // 1000万円
};

export const JOB_OFFER_KIND_MAPPING = {
  '1': '0', // エージェントサービスのみ
  '2': '2', // 直接応募のみ
};

export const KEYWORD_CATEGORY_MAPPING = {
  '1': '1', // 求人掲載内容全て
  '2': '2', // 社名
  '3': '3', // 職種名
  '4': '4', // 勤務地
  '5': '9', // 経験・スキル
};

export const IS_NEW_ARRIVAL = '1'; // 新着を示すOP値
export const IS_NEAR_DEDLINE = '20'; // 締切間近を示すOP値
